import iconNoResults from "../../assets/icon_noResult.svg";
import IconError from "../../assets/icon_error.svg";
const ResultInform = ({ unavailable, label }) => {
  return (
    <div className="flex flex-col items-center py-24 gap-7">
      <span>
        {unavailable ? (
          <img src={IconError} alt="" />
        ) : (
          <img src={iconNoResults} alt="" />
        )}
      </span>
      <p className="text-2xl font-semibold text-center">{label}</p>
    </div>
  );
};

export default ResultInform;
